import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import './OrderItems.css'
import { ShopContext } from '../../Context/ShopContext'
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { useLocation } from "react-router-dom";


const imgUrl = process.env.REACT_APP_ASSET_PATH;
const OrderItems = () => {

    const [all_product, setAllProduct] = useState([]);
    const [promo, setPromo] = useState("");
    useEffect(() => {
        axios.get(apiURL + `api/products/all`, {
            headers: {
                Accept: 'application/json',
                "ngrok-skip-browser-warning": "10424"
            }
        }).then((res) => {
            setAllProduct(res.data);
        }).catch((err) => console.log(err));

        const storedPromo = JSON.parse(localStorage.getItem("promo"));
        if (storedPromo && storedPromo.code !== null) {
            let getUrl = apiURL + `api/promo/check?code=${encodeURIComponent(storedPromo.code)}`;
            axios.get(getUrl, {
                headers: {
                    Accept: 'application/json',
                    "ngrok-skip-browser-warning": "10434"
                }
            }).then((res) => {
                setPromo(res.data);
            }).catch((err) => console.log(err));
        }

        setTimeout(() => {
            window.scrollTo(0, 0); // Scroll to the top after a slight delay
        }, 100); // Delay of 100 milliseconds, adjust as needed

    }, []); // Empty dependency array ensures this only runs on component mount


    const [loading, setLoading] = useState([false]);

    let navigate = useNavigate();
    const { getTotalCartAmount, cartItems, getPromoDiscount } = useContext(ShopContext);

    const apiURL = process.env.REACT_APP_API_URL;

    const [formData, setFormData] = useState({
        payment: 'cash',
        delivery: 'pickup',
        address: '',
        email: '',
        pincode: '6037'
    });

    const isCartEmpty = useState(!cartItems ? true : false);
    const [textarea, setTextarea] = useState("");
    const [mobile, setMobile] = useState("");
    const [payment, setPayment] = useState("cash");
    const [pin, setPin] = useState("");
    const [hasTyped, setHasTyped] = useState(false);
    const [hasEmailTyped, setHasEmailTyped] = useState(false);
    const [email, setEmail] = useState("");
    const [showDelivery, setShowDelivery] = useState(false);
    const isLoggedIn = localStorage.getItem("user") ? true : false;
    const [mobileError, setMobileError] = useState(true);
    const [emailError, setEmailError] = useState(isLoggedIn ? false : true);
    const [gmailError, setGmailError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    
    const handleTextChange = (event) => {
        let value = event.target.value;
        formData.address = value;
        setTextarea(value);
        if (!value.trim()) {
            alert("Address is empty");
            setAddressError(true);
        } else {
            setAddressError(false);
        }
    }

    const handleMobileChange = (event) => {
        let value = event.target.value;

        // Mark that user has started typing
        setHasTyped(true);

        const mobileRegex = /^02[0-2,6-9](\s|-|)?\d{3,4}(\s|-|)?\d{3,4}$/;

        if (!/^[0-9\s-]*$/.test(value)) {
            setMobileError(true);
            setMobile(value);
            return;
        }

        setMobile(value);
        formData.mobile = value;

        if (mobileRegex.test(value)) {
            setMobileError(false);
        } else {
            setMobileError(true);
        }
    };

    const handleEmailChange = (event) => {
        let value = event.target.value;
        setHasEmailTyped(true);

        const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

        if (/^.*@gmail..*$/.test(value)) {
            setGmailError(true);
            return;
        } else {
            setGmailError(false);
        }

        setEmail(value);
        formData.email = value;

        if (emailRegex.test(value)) {
            setEmailError(false);
        } else {
            setEmailError(true);
        }
    };


    const handlePaymentChange = (value) => {
        setPayment(value);
        formData.payment = value;
    };

    function handleDelivery() {
        setShowDelivery(true);
        formData.delivery = "delivery";
        if (!textarea.trim()) {
            setAddressError(true);
        }
    }

    function handlePickup() {
        setShowDelivery(false);
        formData.delivery = "pickup";
        setAddressError(false);
    }

    const handlePinChange = (event) => {
        formData.pincode = event.target.value;
        setPin(event.target.value)
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);

        let totalqty = 0;
        let itemAvailable = true;
        let products = [];
        let unavailableProduct = "";
        all_product.map((e) => {
            if (e.quantity < cartItems[e.id]) {
                itemAvailable = false;
                unavailableProduct = e.name;
            }
            if (itemAvailable && cartItems[e.id] > 0) {
                totalqty += cartItems[e.id];
                e.quantity = cartItems[e.id];
                products.push(e);
            }
        })
        if (!itemAvailable) {
            setLoading(false);
            alert(unavailableProduct + " has been sold out, please try again with less quantity.");
            return;
        } else if (promo !== "" && promo.valid === false) {
            setLoading(false);
            alert("Promo code is invalid, you will be redirected to Cart page");
            navigate('/cart', { replace: true });
        } else {
            let date = new Date();
            let uniqueId = "SAI" + date.getFullYear().toString() + (date.getMonth() + 1) + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString();
            let amount = getPromoDiscount() > 0 ? getTotalCartAmount() - getPromoDiscount() : getTotalCartAmount();
            let output = {
                "id": uniqueId,
                "amount": amount,
                "email": formData.email === "" ? JSON.parse(localStorage.getItem("user")).email : formData.email,
                "username": formData.email === "" ? JSON.parse(localStorage.getItem("user")).name : "Customer",
                "address": formData.address,
                "mobile": formData.mobile,
                "qty": totalqty,
                "delivery": formData.delivery,
                "pin": formData.pincode,
                "payment": formData.payment,
                "products": products,
                "delivered": false
            }

            axios.post(apiURL + `api/order/save`, output, {
                headers: {
                    Accept: 'application/json',
                    "ngrok-skip-browser-warning": "10422"
                }
            }).then((res) => {
                setLoading(false);
                alert(`Order Placed successfully with id:` + res.data);
                localStorage.removeItem("cartList");
                localStorage.removeItem("promo");
                navigate('/', { replace: true });
                window.location.reload();
            }).catch((err) => {
                console.log(err);
                setLoading(false);
                alert(`Error occured, please try later`);
            });
        }
    }

    const location = useLocation();
    const totalCartAmount = location.state?.totalCartAmount || 0;

    return (
        <div>
            {loading === true ? <div className='spinner'><RotatingLines
                visible={true}
                height="96"
                width="96"
                color="grey"
                strokeWidth="5"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
            /></div> :
                <div className='checkout-form'>
                    <h2>Checkout Details</h2>
                    <form onSubmit={handleSubmit}>
                        {!isLoggedIn && <div className='row'>
                            <div className='col-50'>
                                <label className={emailError ? "validRed" : ""}>Email:*</label>
                            </div>
                            <div className='col-50'>
                                <input type="text" value={email} onChange={handleEmailChange} />
                                {hasEmailTyped && emailError && email.length > 0 && (
                                    <p className="error-text">❌ Invalid email id!</p>
                                )}
                                {/* {hasEmailTyped && gmailError && email.length > 0 && (
                                    <p className="error-text">❌ Please use login for gmail account!</p>
                                )} */}
                                {gmailError && (
                                    <div className="login-popup">
                                    <div className="login-popup-content">
                                        <h3>Please Login</h3>
                                        <p>Please login for gmail accounts or use other email.</p>
                                        <button onClick={() => setGmailError(false)}>Ok</button>
                                    </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        }
                        <div className='row'>
                            <div className='col-50'>
                                <label className={mobileError ? "validRed" : ""}>Mobile:*</label>
                            </div>
                            <div className='col-50'>
                                <input type="text" value={mobile} onChange={handleMobileChange} />
                                {hasTyped && mobileError && mobile.length > 0 && (
                                    <p className="error-text">❌ Invalid mobile number!</p>
                                )}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-50'>
                                <label>Choose Payment Type:</label>
                            </div>
                            <div className='col-50'>
                                <label>
                                    <input type="radio" name="payment" value="cash" defaultChecked onChange={() => handlePaymentChange("cash")} />Pay by Cash
                                </label>
                                <label>
                                    <input type="radio" name="payment" value="card" onChange={() => handlePaymentChange("card")} />Pay by Card at delivery / pickup
                                </label>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-50'>
                                <label>Choose Delivery Type:</label>
                            </div>
                            <div className='col-50'>
                                {totalCartAmount < 50 && (
                                    <p style={{ color: "red", marginBottom: "5px" }}>
                                        Minimum order amount for delivery is $50.
                                    </p>
                                )}
                                <label title={totalCartAmount < 50 ? "Delivery is not available for orders less than $50" : ""}>
                                    <input type="radio" name="deliveryType" value="delivery" checked={formData.delivery === "delivery"} onChange={handleDelivery} disabled={totalCartAmount < 50} />Delivery
                                </label>
                                <label>
                                    <input type="radio" name="deliveryType" value="pickup" checked={formData.delivery === "pickup"} onChange={handlePickup} />Pickup
                                </label>
                            </div>
                        </div>
                        {showDelivery && (<div className='row'>
                            <div className='col-50'>
                                <label>Select Pincode for delivery:</label>
                            </div>
                            <div className='col-50'>
                                <select value={pin} onChange={handlePinChange}>
                                    <option value="6037">6037</option>
                                    <option value="6035">6035</option>
                                    <option value="6011">6011</option>
                                    <option value="5028">5028</option>
                                    <option value="5022">5022</option>
                                    <option value="5024">5024</option>
                                    <option value="5010">5010</option>
                                    <option value="5012">5012</option>
                                    <option value="5014">5014</option>
                                    <option value="5016">5016</option>
                                </select>
                            </div>
                        </div>)}
                        {showDelivery && (<div className='row'>
                            <div className='col-50'>
                                <label className={textarea.trim() === "" ? "validRed" : ""}>Enter your Address:*</label>
                            </div>
                            <div className='col-50'>
                                <textarea value={textarea} onChange={handleTextChange} />
                            </div>
                        </div>)
                        }
                        {formData.delivery === "delivery" &&
                            <div className='deliveryFee'>
                                *Delivery fee of $10 will be applicable for orders below $150
                            </div>
                        }
                        {/* <button type="submit">Place Order</button> */}
                        <div className='submitButton'>
                            <button className="btn"
                                disabled={addressError || mobileError || emailError || gmailError || mobile === "" || (showDelivery && textarea.trim() === "")}
                                type="submit">
                                Place Order
                            </button>
                        </div>
                    </form>
                </div>
            }
        </div>
    )
}

export default OrderItems